module.exports = "/_next/static/images/Hero@2x-0f1aa91d0ad380c2435fb5d31956f1f2.webp";